import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useDecodedToken } from '../app/hooks';
import { endImpersonation } from '../features/auth/authSlice';

// Shown whenever the current token is an impersonation token minted from the
// superadmin dashboard -- makes the borrowed-identity session unmistakable
// and gives the one-click way back to the owner's own session.
export default function ImpersonationBanner() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const decodedToken = useDecodedToken();

    if (!decodedToken?.impersonation) {
        return null;
    }

    const handleExit = () => {
        dispatch(endImpersonation());
        navigate('/superadmin');
    };

    return (
        <Alert
            severity="warning"
            sx={{ borderRadius: 0, justifyContent: 'center' }}
            action={
                <Button color="inherit" size="small" onClick={handleExit}>
                    {t('superadmin.exitImpersonation')}
                </Button>
            }
        >
            {t('superadmin.impersonationBanner')}
        </Alert>
    );
}
